module.exports = __webpack_public_path__ + "img/网页 (12).c61edc3a.svg";